import MissingSuccession from "../../../../src/notes/missing-succession";
import * as React from 'react';
export default {
  MissingSuccession,
  React
};